// extracted by mini-css-extract-plugin
module.exports = {"link":"MenuNavDropDown_link__nB_54","link_disabled":"MenuNavDropDown_link_disabled__2War7","qr":"MenuNavDropDown_qr__IVT8S"};